import { FC } from "react";
import { ProgramExchangeDetailsType } from "src/Modules/PointsExchange/constants";
import { ExchangeDetailsCard, ExchangeModal, TermsBar } from "../components";
import ExchangeDetails from "../components/ExchangeDetails/ExchangeDetails";

const PointsExchangeWeb: FC<ProgramExchangeDetailsType> = ({
  destinationProgram,
  loading,
  exchangeInfo,
  termsAndConditions,
  requiredFields,
}) => {
  return (
    <div className="flex w-full items-start gap-10">
      <div className="flex-2 rounded-xs flex flex-col gap-6 p-6 shadow-sm">
        <ExchangeDetailsCard destinationProgram={destinationProgram} exchangeInfo={exchangeInfo} />
        <ExchangeDetails loading={loading} exchangeInfo={exchangeInfo} destinationProgram={destinationProgram} requiredFields={requiredFields} />
        <ExchangeModal destination={destinationProgram} exchangeInfo={exchangeInfo} termsAndConditions={termsAndConditions} />
      </div>
      <div className="rounded-xs flex-1 shadow-sm">
        <TermsBar terms={termsAndConditions} loading={loading} />
      </div>
    </div>
  );
};

export default PointsExchangeWeb;
